"use client";

import { LockedOverlay } from "./LockedOverlay";
import { FakeDataWatermark } from "./FakeDataWatermark";

type LockedTopRankListProps = {
  title: string;
  headerRightLabel?: string;
  primaryColor: string;
  rows?: number;
};

const FAKE_NAMES = [
  "Phantom Odyssey",
  "Stellar Vanguard",
  "Crimson Protocol",
  "Neon Abyss Zero",
  "Ironclad Legacy",
  "Void Breakers",
  "Arctic Siege II",
  "Drift Horizon",
  "Eclipse Frontier",
  "Shadow Meridian",
];

const FAKE_VALUES = [
  "24,891",
  "19,472",
  "16,038",
  "13,205",
  "11,764",
  "9,503",
  "8,217",
  "7,680",
  "6,342",
  "5,019",
];

export function LockedTopRankList({
  title,
  headerRightLabel,
  primaryColor,
  rows = 10,
}: LockedTopRankListProps) {
  return (
    <div data-nosnippet className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden shadow-lg relative h-full">
      {/* Header */}
      <div className="relative block border-b border-[#2a475e] bg-[#1b2838]">
        <div className="relative px-2 py-1 sm:px-2.5 sm:py-1.5">
          <div className="flex items-center justify-between gap-2">
            <h2 className="text-white flex items-center gap-1.5 text-[14px] font-semibold">
              <span className="tracking-wide">{title}</span>
            </h2>
            {headerRightLabel && (
              <div className="text-[11px] font-semibold text-white/60 tracking-wide uppercase">
                {headerRightLabel}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Fake blurred rows */}
      <div className="divide-y divide-[#2a475e] select-none blur-[6px] pointer-events-none relative">
        {Array.from({ length: rows }, (_, i) => (
          <div
            key={i}
            className={`flex items-center gap-1.5 sm:gap-2.5 pr-2 sm:pr-2.5 pl-0 py-0 ${
              i % 2 === 1 ? "bg-[#15212f]" : ""
            }`}
          >
            {/* Fake image */}
            <div className="flex-shrink-0 w-[80px] h-[30px] sm:w-[100px] sm:h-[37px] bg-[#2a475e]" />

            {/* Fake name */}
            <div className="flex-1 min-w-0">
              <span className="text-[13px] sm:text-[15px] leading-tight font-medium text-white truncate block">
                {FAKE_NAMES[i % FAKE_NAMES.length]}
              </span>
            </div>

            {/* Fake value */}
            <div className="flex-shrink-0 tabular-nums text-right min-w-[60px] sm:min-w-[80px]">
              <span
                className="text-[13px] sm:text-[15px]"
                style={{ color: primaryColor }}
              >
                {FAKE_VALUES[i % FAKE_VALUES.length]}
              </span>
            </div>
          </div>
        ))}
        <FakeDataWatermark />
      </div>

      {/* Lock overlay */}
      <LockedOverlay compact surface="main_page_mlt" />
    </div>
  );
}
